import { ConnectorIds, PRODUCT_CONNECTOR_MAP, connectorHasProduct } from '@/common/constants';
import { IPlatformRole } from '@/common/dto/auth/UserInfo/Interface';

export const checkIfUserHasTheApp = (connectorId: ConnectorIds, platformRoles: IPlatformRole[]) => {
  const productNames = platformRoles.map((pR) => pR.productId);
  const connectorProductId =
    connectorId && connectorHasProduct(connectorId)
      ? PRODUCT_CONNECTOR_MAP[connectorId]
      : undefined;

  return !(productNames.indexOf(connectorProductId) === -1);
};
